// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".clover-response-wrap aside#leftNav,.clover-response-wrap nav{display:none}.clover-response-wrap .h-screen-appheader{height:100vh;display:flex;flex-direction:column;justify-content:center}.clover-response-wrap .min-w-\\[740px\\]{min-width:100%}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
